import { createContext } from 'react'
import type { Message } from '@nexus/shared'

/**
 * Liga a lista de mensagens ao campo de escrita.
 *
 * Clicar em "responder" numa mensagem qualquer precisa alcançar o composer, que
 * está em outro ramo da árvore. Um contexto é mais direto do que subir esse
 * estado até o topo e passar callbacks por três níveis.
 */
export interface ComposerHandle {
  setReplyTo: (message: Message | null) => void
  focus: () => void
  insertText: (text: string) => void
}

export const MessageComposerContext = createContext<ComposerHandle | null>(null)
